import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=157eda2a&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=157eda2a&prod&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=157eda2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157eda2a",
  null
  
)

export default component.exports